export enum Actions {
    SET_COMPANY_DATA = "set company data",
    CLEAR_COMPANY_DATA = "clear company data",
    SET_REGISTRATION_COMPLETE = "register complete",
    SET_REGISTER_ERR = "register err",
    CLEAR_ERR = "clear error",
    TOGGLE_PRICING = "togglePricing",
    TOGGLE_REGULATIONS = "toggleRegulations"
  }